import oikosApi from '../../../services/oikos'
import qs from 'qs'
import { getRegs } from '../../../utils/fc'
import { contrFornEventoRefDate } from './budgetDashboardHelpers'

const contrFornListFields = {
  contrForn_id: 'contrForn_id',
  contrForn_num: 'contrForn_num',
  contrForn_desc: 'contrForn_desc',
  contrForn_obj: 'contrForn_obj',
  contrForn_vlrGlobal: 'contrForn_vlrGlobal',
  contrForn_dtAssin: 'contrForn_dtAssin',
  contrForn_dtVigIni: 'contrForn_dtVigIni',
  contrForn_dtVigFim: 'contrForn_dtVigFim',
  contrFornStatus_id: 'contrFornStatus_id',
  contrFornTp_id: 'contrFornTp_id',
  contrForn_parteTab: 'contrForn_parteTab',
  contrForn_parteId: 'contrForn_parteId',
  orcItem_id: 'orcItem_id',
  '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = contrForn.orcItem_id LIMIT 1)': 'orcItem_desc',
  '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = contrForn.contrForn_parteId AND contrForn.contrForn_parteTab = "pf" LIMIT 1)': 'contratado_nomePf',
  '(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = contrForn.contrForn_parteId AND contrForn.contrForn_parteTab = "pj" LIMIT 1)': 'contratado_nomePj',
  '(SELECT contrFornStatus_nome FROM contrFornStatus WHERE contrFornStatus.contrFornStatus_id = contrForn.contrFornStatus_id LIMIT 1)': 'contrFornStatus_nome',
  '(SELECT contrFornTp_nome FROM contrFornTp WHERE contrFornTp.contrFornTp_id = contrForn.contrFornTp_id LIMIT 1)': 'contrFornTp_nome',
  '(SELECT tpMinuta_nome FROM tpMinuta WHERE tpMinuta.tpMinuta_id = contrForn.tpMinuta_id LIMIT 1)': 'tpMinuta_nome',
  '(SELECT nivel3 FROM viewRubr_OrcItem WHERE orcItem_id = contrForn.orcItem_id LIMIT 1)': 'rubrica_nome',
}

const pedidoCompraListFields = {
  pedidoCompra_id: 'pedidoCompra_id',
  pedidoCompra_num: 'pedidoCompra_num',
  pedidoCompra_desc: 'pedidoCompra_desc',
  pedidoCompra_vlrLimite: 'pedidoCompra_vlrLimite',
  pedidoCompra_dtSolicitacao: 'pedidoCompra_dtSolicitacao',
  pedidoCompra_dtLimiteEntrega: 'pedidoCompra_dtLimiteEntrega',
  pedidoCompra_dtVigIni: 'pedidoCompra_dtVigIni',
  pedidoCompra_dtVigFim: 'pedidoCompra_dtVigFim',
  compraStatus_id: 'compraStatus_id',
  orcItem_id: 'orcItem_id',
  pf_id: 'pf_id',
  '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = pedidoCompra.orcItem_id LIMIT 1)': 'orcItem_desc',
  '(SELECT compraStatus_nome FROM compraStatus WHERE compraStatus.compraStatus_id = pedidoCompra.compraStatus_id LIMIT 1)': 'compraStatus_nome',
  '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = pedidoCompra.pf_id LIMIT 1)': 'pf_nomeExibicao',
  '(SELECT nivel3 FROM viewRubr_OrcItem WHERE orcItem_id = pedidoCompra.orcItem_id LIMIT 1)': 'rubrica_nome',
}

export const contrFornEventoDetailFields = {
  contrFornEvento_id: 'contrFornEvento_id',
  contrForn_id: 'contrForn_id',
  contrFornEvento_num: 'contrFornEvento_num',
  contrFornEvento_desc: 'contrFornEvento_desc',
  contrFornEvento_vlr: 'contrFornEvento_vlr',
  contrFornEvento_dtPrev: 'contrFornEvento_dtPrev',
  contrFornEvento_pgtoPrazoDias: 'contrFornEvento_pgtoPrazoDias',
  contrFornEvento_aprovLiberado: 'contrFornEvento_aprovLiberado',
  bdro_id: 'bdro_id',
  '(SELECT orcItem_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'orcItem_id',
  '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)))': 'pf_emailProf',
  '(SELECT contrForn_parteTab FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_parteTab',
  '(SELECT contrForn_parteId FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_parteId',
  '(SELECT contrFornStatus_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrFornStatus_id',
  '(SELECT contrFornTp_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrFornTp_id',
  '(SELECT contrForn_desc FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_desc',
  '(SELECT CASE WHEN contrForn.contrForn_parteTab = "pf" THEN (SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = contrForn.contrForn_parteId LIMIT 1) ELSE (SELECT pj_razaosocial FROM pj WHERE pj.pj_id = contrForn.contrForn_parteId LIMIT 1) END FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'fornecedor_nome',
  [`(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 24 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'contrFornEvento' AND documentoVinc.documentoVinc_tabId = contrFornEvento.contrFornEvento_id ORDER BY documentoVinc_id DESC) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)`]: 'arquivo_caminho_evidencia',
  [`(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = 'bdro' AND documentoVinc.documentoVinc_tabId = contrFornEvento.bdro_id ORDER BY documentoVinc_id DESC) ORDER BY doc.documento_id DESC LIMIT 1) ORDER BY arquivo_id DESC LIMIT 1)`]: 'arquivo_caminho_nota_fiscal',
  '(SELECT bdro_dtVenc FROM bdro WHERE bdro.bdro_tabRef = "contrFornEvento" AND bdro.bdro_tabId = contrFornEvento.contrFornEvento_id AND bdro.bdro_ativo = 1 ORDER BY bdro.bdro_id DESC LIMIT 1)': 'bdro_dtVenc',
  '(SELECT bdro_dtQuit FROM bdro WHERE bdro.bdro_tabRef = "contrFornEvento" AND bdro.bdro_tabId = contrFornEvento.contrFornEvento_id AND bdro.bdro_ativo = 1 ORDER BY bdro.bdro_id DESC LIMIT 1)': 'bdro_dtQuit',
}

async function safeFetch(label, fn, fallback = []) {
  try {
    const result = await fn()
    return result ?? fallback
  } catch (err) {
    console.error(`[budget-item-modal] falha ao carregar ${label}:`, err?.data || err)
    return fallback
  }
}

export function getFornecedorNome(row) {
  if (!row) return '—'
  return row.contratado_nomePf || row.contratado_nomePj || row.fornecedor_nome || '—'
}

export function getEventoVencimento(row) {
  if (row?.bdro_dtVenc) return row.bdro_dtVenc
  const ref = contrFornEventoRefDate(row)
  if (ref) return ref
  return row?.contrFornEvento_dtPrev || null
}

const parcelasExtraFields = {
  '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1) LIMIT 1)': 'orcItem_desc',
  '(SELECT nivel3 FROM viewRubr_OrcItem WHERE orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1) LIMIT 1)': 'rubrica_nome',
  '(SELECT contrForn_num FROM contrForn WHERE contrForn.contrForn_id = contrFornEvento.contrForn_id LIMIT 1)': 'contrForn_num',
}

export async function fetchContratosByOrcItem(orcItemId) {
  if (!orcItemId) return []
  return safeFetch('contratos', async () => {
    const rows = await getRegs('contrForn', {
      orcItem_id: Number(orcItemId),
      contrForn_ativo: 1,
    }, contrFornListFields)
    return (rows || []).sort((a, b) => (a.contrForn_num || '').localeCompare(b.contrForn_num || '', 'pt-BR'))
  })
}

export async function fetchPedidosByOrcItem(orcItemId) {
  if (!orcItemId) return []
  return safeFetch('pedidos', async () => {
    const rows = await getRegs('pedidoCompra', {
      orcItem_id: Number(orcItemId),
      pedidoCompra_ativo: 1,
    }, pedidoCompraListFields)
    return (rows || []).sort((a, b) => (a.pedidoCompra_num || '').localeCompare(b.pedidoCompra_num || '', 'pt-BR'))
  })
}

export async function fetchContratoEventos(contrFornId) {
  if (!contrFornId) return []
  return safeFetch('eventos', async () => {
    const rows = await getRegs('contrFornEvento', {
      contrForn_id: Number(contrFornId),
      contrFornEvento_ativo: 1,
    }, contrFornEventoDetailFields)
    return rows || []
  })
}

export async function fetchCompraCotacoes(pedidoCompraId) {
  if (!pedidoCompraId) return []
  return safeFetch('cotações', async () => {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'compraCotacao',
      data: { pedidoCompra_id: Number(pedidoCompraId) },
      fields: {
        compraCotacao_id: 'compraCotacao_id',
        compraCotacao_vlr: 'compraCotacao_vlr',
        compraCotacao_dtEnvio: 'compraCotacao_dtEnvio',
        compraCotacao_dtResposta: 'compraCotacao_dtResposta',
        compraStatus_id: 'compraStatus_id',
        contrForn_id: 'contrForn_id',
        '(SELECT CASE WHEN compraCotacao.contrForn_parteTab = "pf" THEN (SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = compraCotacao.contrForn_parteId LIMIT 1) ELSE (SELECT pj_razaosocial FROM pj WHERE pj.pj_id = compraCotacao.contrForn_parteId LIMIT 1) END)': 'fornecedor_nome',
        '(SELECT compraStatus_nome FROM compraStatus WHERE compraStatus.compraStatus_id = compraCotacao.compraStatus_id LIMIT 1)': 'compraStatus_nome',
        '(SELECT contrForn_num FROM contrForn WHERE contrForn.contrForn_id = compraCotacao.contrForn_id LIMIT 1)': 'contrForn_num',
      },
    })}`)
    return res?.data || []
  })
}

export async function fetchFornecedor(parteTab, parteId) {
  if (!parteTab || !parteId) return null
  return safeFetch('fornecedor', async () => {
    const rows = await getRegs(parteTab, {
      [`${parteTab}_id`]: Number(parteId),
    }, {}, false)
    return rows?.[0] || null
  }, null)
}

const PARCELAS_FETCH_TIMEOUT_MS = 20000
const PARCELAS_BATCH_SIZE = 40

function withTimeout(promise, ms = PARCELAS_FETCH_TIMEOUT_MS) {
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error('timeout')), ms)
    }),
  ])
}

function chunkArray(arr, size) {
  const chunks = []
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size))
  }
  return chunks
}

async function fetchParcelasBatch(orcItemIds) {
  const contratoRows = await getRegs('contrForn', {
    orcItem_id: `!IN!(${orcItemIds.join(',')})`,
    contrForn_ativo: 1,
  }, {
    contrForn_id: 'contrForn_id',
  }, false)

  const contrFornIds = [...new Set((contratoRows || []).map(r => Number(r.contrForn_id)).filter(Boolean))]
  if (!contrFornIds.length) return []

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'contrFornEvento',
    data: {
      contrForn_id: `!IN!(${contrFornIds.join(',')})`,
      contrFornEvento_ativo: 1,
    },
    fields: {
      ...contrFornEventoDetailFields,
      ...parcelasExtraFields,
    },
  })}`)

  return res?.data || []
}

export async function fetchParcelasByOrcItemIds(orcItemIds) {
  if (!orcItemIds?.length) return []
  return safeFetch('parcelas', async () => {
    const batches = chunkArray(orcItemIds, PARCELAS_BATCH_SIZE)
    const all = []
    for (const batch of batches) {
      const rows = await withTimeout(fetchParcelasBatch(batch))
      all.push(...rows)
    }
    return all
  })
}

export async function fetchContratoById(contrFornId) {
  if (!contrFornId) return null
  return safeFetch('contrato', async () => {
    const res = await getRegs('contrForn', {
      contrForn_id: Number(contrFornId),
      contrForn_ativo: 1,
    }, contrFornListFields, false)
    return res?.[0] || null
  }, null)
}
